var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobiPay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.000313868 22V8.49743C0.000313868 8.49743 -0.171936 1.47271 7.55395 0H17.3521V9.08548C17.3521 9.08548 16.7899 17.2101 7.98616 16.8671V12.1555L11.6552 8.57981L13.3819 10.2204L13.4252 3.82698L6.8026 3.79197L8.56208 5.49537L3.90817 9.98455V18.2369L0.000313868 22Z",
    fill: "#101018"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.85426 3.71826L8.57387 5.42044L4.02817 9.90641L5.4567 11.3307V17.6619L8.01133 16.7841V12.0758L11.595 8.50268L13.2816 10.1421L13.3239 3.75325L6.85426 3.71826Z",
    fill: "#DA5026"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobiPay);
export default __webpack_public_path__ + "static/media/Mobi-pay.e03e706dd11de94cb70fcc3558bf00a8.svg";
export { ForwardRef as ReactComponent };